import { LocalizedText } from '@mews/framework';
import { Stack, Card, Typography } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { useRepositoryQuery } from '@mews-commander/data-access';
import { getFullName } from '@mews-commander/utils';

export const PayerSummary = ({ payerAccountId }: { payerAccountId: string }) => {
    const { data } = useRepositoryQuery('accounts', 'getAll', { accountIds: [payerAccountId] });

    const companies = data?.companies ?? [];
    const customers = data?.customers ?? [];

    const companyName = companies.length > 0 && companies[0]?.name;
    const customerName =
        customers.length > 0 &&
        getFullName({
            firstName: customers[0]?.firstName,
            lastName: customers[0]?.lastName,
        });
    const ownerName = customerName || companyName || null;

    return (
        <Card variant="highlighted" padding="200" data-test-id="payer-summary-card">
            {ownerName && (
                <Stack distribution="space-between" itemAlignment="center">
                    <Typography as="span" textStyle="bodyMedium">
                        <LocalizedText textKey={TextKey.CityLedgerPaymentOwner} />
                    </Typography>

                    <Typography as="span" textStyle="bodyMedium">
                        {ownerName}
                    </Typography>
                </Stack>
            )}

            <Stack distribution="space-between" itemAlignment="center">
                <Typography as="span" textStyle="bodySmall">
                    <LocalizedText textKey={TextKey.CityLedgerPaymentOwnerHelperText} />
                </Typography>
            </Stack>
        </Card>
    );
};
